import { NavSidebarItemData } from '@/features/layout/Sidebars/common/components/SidebarBase/SidebarNavigation/Items/NavSidebarItem/types';
import { ComponentProps, FC } from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { BASE_SIDEBAR_ITEM_STYLES, BaseSidebarItem } from '../BaseSidebarItem';

type NavSidebarItemProps = ComponentProps<typeof BaseSidebarItem> &
  NavSidebarItemData & {
    classNames?: {
      item?: string;
    };
  };

export const NavSidebarItem: FC<NavSidebarItemProps> = ({ path, classNames, ...rest }) => {
  const match = useRouteMatch({
    path,
    strict: true,
  });

  return (
    <li>
      <NavLink
        to={path}
        className={twMerge(BASE_SIDEBAR_ITEM_STYLES, match?.isExact ? 'pointer-events-none' : '', classNames?.item)}
        activeClassName='bg-primary-hover *:text-secondary-hover [&>svg]:text-quaternary-hover'
      >
        <BaseSidebarItem {...rest} classNames={classNames} />
      </NavLink>
    </li>
  );
};
